import { VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Layout } from '../../components/Layout/Layout';
import { MeterListContent } from './components/Content';
import { MeterList as messages } from './messages';

export const MeterListPage: VFC = () => (
  <Layout headerContent={<FormattedMessage {...messages.meterList} />}>
    <MeterListContent />
  </Layout>
);
